import React from "react";
import "./flow.scss";
import config from "./config";
import { useStore } from "./store";
import Intro from "./sections/intro";
import EndFrame10 from "./sections/end-frame-1-0";
import EndFrame11 from "./sections/end-frame-1-1";
import EndFrame12 from "./sections/end-frame-1-2";
import EndFrame20 from "./sections/end-frame-2-0";
import EndFrame21 from "./sections/end-frame-2-1";
import EndFrame22 from "./sections/end-frame-2-2";
import EndFrame23 from "./sections/end-frame-2-3";
import EndFrame24 from "./sections/end-frame-2-4";
import EndFrame30 from "./sections/end-frame-3-0";
import EndFrame31 from "./sections/end-frame-3-1";
import EndFrame40 from "./sections/end-frame-4-0";
import EndFrame41 from "./sections/end-frame-4-1";
import EndFrame42 from "./sections/end-frame-4-2";
import EndFrame43 from "./sections/end-frame-4-3";
import EndFrame50 from "./sections/end-frame-5-0";
import EndFrame51 from "./sections/end-frame-5-1";
import EndFrame52 from "./sections/end-frame-5-2";
import EndFrame60 from "./sections/end-frame-6-0";
import EndFrame61 from "./sections/end-frame-6-1";
import EndFrame70 from "./sections/end-frame-7-0";
import EndFrame71 from "./sections/end-frame-7-1";

import FullScreenToggle from "./components/full-screen-toggle/full-screen-toggle";
import Music from "../Music";

const PLAYBACK_RATE = process.env.NODE_ENV === "development" ? 1 : 1;

export default function Flow() {
  /** @type React.MutableRefObject<HTMLVideoElement> */
  const video = React.useRef();
  const {
    section,
    setShowEndFrame,
    setSection,
    interacted,
    setMusicPlaying,
    fullscreen,
  } = useStore();
  let focused = true;

  document.addEventListener("visibilitychange", function () {
    focused = !focused;
    if (!focused){
      video.current.pause();
    }else{
      video.current.play();
    }
  });

  React.useEffect(() => {
    // section change + video start logic
    if (!video.current) return;
    const sectionConfig = config.find((video) => video.section === section);
    if (section !== null) {
      setShowEndFrame(false);
      video.current.play().then(() => {
        setMusicPlaying(false);
        if (sectionConfig) {
          video.current.currentTime = sectionConfig.start;
        }
      });
    }
  }, [section]);

  // video play/pause logic
  React.useEffect(() => {
    let currentSection = null;
    let sectionConfig = config.find(
      (video) => video.section === useStore.getState().section
    );
    const subscription = useStore.subscribe(
      (section) => {
        currentSection = section;
        sectionConfig = config.find((video) => video.section === section);
      },
      (state) => state.section
    );
    let raf;
    (function tick() {
      raf = requestAnimationFrame(tick);
      if (!video.current) return;
      if (!sectionConfig) return;
      if (useStore.getState().preventCheck) return;
      const currentTime = video.current.currentTime;
      const endTime = sectionConfig.end;
      if (currentTime >= endTime) {
        if (sectionConfig.section === 1.3 || sectionConfig.section === 1.2) {
          setShowEndFrame(false);
          setSection(2.0);
          return;
        }
        if (sectionConfig.section === 2.5) {
          setShowEndFrame(false);
          setSection(3.0);
          return;
        }
        if (sectionConfig.section === 3.2) {
          setShowEndFrame(false);
          setSection(4.0);
          return;
        }
        if (sectionConfig.section === 4.2) {
          setShowEndFrame(false);
          setSection(5.0);
          return;
        }
        if (sectionConfig.section === 5.2 || sectionConfig.section === 5.3) {
          setShowEndFrame(false);
          setSection(6.0);
          return;
        }

        if (sectionConfig.section === 6.1 || sectionConfig.section === 6.2) {
          setShowEndFrame(false);
          setSection(7.0);
          return;
        }

        if (sectionConfig.section === 7.1) {
          setShowEndFrame(false);
          setSection(1.0);
          return;
        }

        setShowEndFrame(true);
        setMusicPlaying(currentSection !== null);
        video.current.pause();
        video.current.currentTime = endTime;
      }
    })();
    return () => {
      subscription();
      cancelAnimationFrame(raf);
    };
  }, []);

  React.useEffect(() => {
    if (!video.current) return;
    video.current.playbackRate = PLAYBACK_RATE;
  }, []);

  return (
    <div className={`flow ${fullscreen ? "fullscreen" : ""}`}>
      <Music url="https://media.kasperskydaily.com/wp-content/uploads/sites/92/2021/03/08091524/Lemonade-HoldMusicforOptionScenes.mp3" />

      <div className="flow-wrapper">
        <div className="flow-container">
          <div className="flow-content">
            <FullScreenToggle />
            <div className="flow-video">
              <video
                src="https://media.kasperskydaily.com/wp-content/uploads/sites/92/2021/02/20043543/flow.mp4"
                playsInline
                ref={video}
                muted={!interacted}
                controls={process.env.NODE_ENV === "development"}
              />
            </div>

            {/* sections */}
            <Intro />
            <EndFrame10 />
            <EndFrame11 />
            <EndFrame12 />
            <EndFrame20 />
            <EndFrame21 />
            <EndFrame22 />
            <EndFrame23 />
            <EndFrame24 />
            <EndFrame30 />
            <EndFrame31 />
            <EndFrame40 />
            <EndFrame41 />
            <EndFrame42 />
            <EndFrame43 />
            <EndFrame50 />
            <EndFrame51 />
            <EndFrame52 />
            <EndFrame60 />
            <EndFrame61 />
            <EndFrame70 />
            <EndFrame71 />
          </div>
        </div>
      </div>
    </div>
  );
}
